/**
 * 文字选中状态管理 Store
 *
 * 管理文字选中快捷菜单的状态：
 * - 弹窗显示/隐藏
 * - 选中数据存储
 * - 提供弹窗控制方法
 */

import { create } from 'zustand';
import type { TextSelectionData } from '../types/textSelection';

// ==================== 类型定义 ====================

/** 文字选中状态接口 */
export interface TextSelectionState {
  /** 弹窗是否可见 */
  isVisible: boolean;
  /** 当前选中的数据 */
  selectionData: TextSelectionData | null;

  // ===== 方法 =====
  /** 显示弹窗 */
  showPopup: (data: TextSelectionData) => void;
  /** 隐藏弹窗 */
  hidePopup: () => void;
}

// ==================== 创建 Store ====================

export const useTextSelectionStore = create<TextSelectionState>((set) => ({
  // ===== 初始状态 =====
  isVisible: false,
  selectionData: null,

  // ===== 方法实现 =====

  showPopup: (data: TextSelectionData) => {
    set({
      isVisible: true,
      selectionData: data
    });
  },

  hidePopup: () => {
    set({
      isVisible: false,
      selectionData: null
    });
  }
}));

export default useTextSelectionStore;
